import { Attribute } from '@/client/types/Listings';

const carPassUrlKey = 'carPassUrl';

export const getCarPassUrl = (attributes: Attribute[]): Attribute | undefined => {
  return attributes.find((x) => x.key === carPassUrlKey);
};

export const getEnergyLabel = (attributes: Attribute[]): Attribute | undefined => {
  return attributes.find((x) => x.key === 'energyLabel');
};

export const getMileage = (attributes: Attribute[]): Attribute | undefined => {
  return attributes.find((x) => x.key === 'mileage');
};

export const getRegularAttributes = (attributes: Attribute[]): Attribute[] => {
  return attributes.filter(
    (x) =>
      x.key !== 'energyLabel' &&
      x.key !== carPassUrlKey &&
      x.key !== 'mileage' &&
      x.key !== 'options' &&
      x.key !== 'model' &&
      x.key !== 'body' &&
      x.key !== 'fuel' &&
      x.key !== 'deeplink',
  );
};
